import Box from '../../components/layout/Box';

const EmptySearch = () => {
  return (
    <Box
      backgroundColor="cardBackgroundColor"
      className="py-5"
      style={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <h3>Tyvärr, här var det tomt...</h3>
      <div
        style={{
          textAlign: 'center',
        }}
      >
        Vi kunde inte hitta något med din nuvarande sökning. Testa att sök med
        hela ISBN-numret.
      </div>
    </Box>
  );
};

export default EmptySearch;
